export const PROBLEM_QUESTION_OVERRIDES = {
  'Two Sum': {
    statement: `
<p>You are given an integer array <strong>nums</strong> and an integer <strong>target</strong>.</p>
<p>Find two distinct indices such that <strong>nums[i] + nums[j] = target</strong>, and return those indices.</p>
<p>You may assume exactly one valid answer exists.</p>
`.trim(),
    description: `
<p>Return the pair of indices, not the values themselves.</p>
<p>The same element cannot be used twice, and answers may be returned in any valid order.</p>
`.trim(),
  },
  'Longest Substring Without Repeating Characters': {
    statement: `
<p>Given a string <strong>s</strong>, find the length of the longest substring without repeating characters.</p>
<p>A substring is contiguous, so characters must appear next to each other in the original string.</p>
`.trim(),
    description: `
<p>As you scan the string, maintain a valid window where all characters are unique.</p>
<p>Return the maximum window length encountered.</p>
`.trim(),
    examples: [
      {
        title: 'Example 1',
        input: '["abcabcbb"]',
        output: '3',
        explanation: 'The answer is "abc" with length 3.',
      },
      {
        title: 'Example 2',
        input: '["bbbbb"]',
        output: '1',
        explanation: 'The answer is "b" with length 1.',
      },
      {
        title: 'Example 3',
        input: '["pwwkew"]',
        output: '3',
        explanation: 'The answer is "wke" with length 3. "pwke" is a subsequence, not a substring.',
      },
    ],
  },
  'Valid Parentheses': {
    statement: `
<p>Given a string containing only the characters '(', ')', '{', '}', '[' and ']', determine whether it is valid.</p>
<p>A valid string must close brackets in the correct order and type.</p>
`.trim(),
  },
  'Merge Intervals': {
    statement: `
<p>You are given an array of intervals where intervals[i] = [starti, endi].</p>
<p>Merge all overlapping intervals and return an array of non-overlapping intervals that cover all given ranges.</p>
`.trim(),
  },
  'Binary Search': {
    statement: `
<p>Given a sorted array of integers <strong>nums</strong> and an integer <strong>target</strong>, return the index of target if it exists.</p>
<p>If target does not exist, return -1.</p>
<p>Use a binary search strategy over the sorted range.</p>
`.trim(),
  },
  'Climbing Stairs': {
    statement: `
<p>You are climbing a staircase with <strong>n</strong> steps.</p>
<p>Each move can be either 1 step or 2 steps.</p>
<p>Return the total number of distinct ways to reach the top.</p>
`.trim(),
  },
};
